import React from 'react';
import moment from 'moment';
import accounting from 'accounting'

import {
    Table,
    Row,
    Col,
    Button,
    Upload,
    Icon,
    Input,
    Card,
    Tag,
    Popconfirm
} from 'antd';

import {
    _postPaymentAdvicePaginate,
    _deletePaymentAdvice
} from '../../services'

import UploadButton from './upload-button'
import NewPaymentAdviceModal from './new-modal';

const ENTITY_TYPES = {
    'user': 'user',
    'enterprise': 'enterprise',
    'corpbilling': 'corpbilling'
}

const VERIFIED_TYPES = {
    'Unverified': false,
    'Verified': true
}

class PaymentAdvice extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            paymentAdvices : [],
            paymentAdvicesCount: 1,
            limit: 20,
            page: 1,

            entityTypeFilter: [],
            verifiedFilter: [],
            
            paymentAdviceNumber_search: '',
            entityName_search: '',

            newPaymentAdviceModalVisible: false,
        }
    }

    render() {
        return(
            <Card title={<div style={{width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <div>Payment Advice</div>
                <Button
                    style={{marginLeft: 'auto'}}
                    type="primary"
                    onClick={() => this.openNewPaymentAdviceModal()}>
                    New Payment Advice
                </Button>
            </div>}>
                {this.renderPaymentAdviceTable()}
                <NewPaymentAdviceModal 
                    visible={this.state.newPaymentAdviceModalVisible}
                    closeModal={this.closeNewPaymentAdviceModal}
                    getPaymentAdvice={this.getPaymentAdvice}
                    />
            </Card>
        )
    }

    componentDidMount() {
        this.getPaymentAdvice()
    }

    getPaymentAdvice = () => {
        const { 
            page, limit,
            entityTypeFilter, verifiedFilter,
            paymentAdviceNumber_search, entityName_search
        } = this.state

        _postPaymentAdvicePaginate({ page, limit, entityTypeFilter, verifiedFilter, paymentAdviceNumber_search, entityName_search })
        .then(_paymentAdvices => {
            this.setState({
                paymentAdvices: _paymentAdvices.data.paymentAdvices,
                paymentAdvicesCount: _paymentAdvices.data.count
            })
        })
    }

    renderPaymentAdviceTable = () => {
        const {paymentAdvices, paymentAdvicesCount, limit, page } = this.state

        const columns = [{
            title: 'Payment Advice Num',
            dataIndex: 'paymentAdviceNumber',
            ...this.getColumnSearchProps('paymentAdviceNumber'),
        },{
            title: 'Entity Type',
            dataIndex: 'entityType',
            filters: Object.keys(ENTITY_TYPES).map(type => ({text: type, value: type})),
            filteredValue: this.state.entityTypeFilter
        },{
            title: 'Entity Id',
            dataIndex: 'entityId',
        },{
            title: 'Entity Name',
            dataIndex: 'entityName',
            // ...this.getColumnSearchProps('entityName'),
        },{
            title: 'Amount',
            dataIndex: 'amount',
            render: (amount) => accounting.formatMoney( amount, '$', 2)

        },{
            title: 'Num Of Invoices',
            dataIndex: 'invoices',
            render: (invoices) => invoices.length || 0
        },{
            title: 'Date Created',
            dataIndex: 'dateCreated',
            render: (dateCreated) =>  moment(dateCreated).format('LL')
        },{
            title: 'Verified',
            dataIndex: 'verified',
            filters: Object.keys(VERIFIED_TYPES).map(type => ({text: type, value: VERIFIED_TYPES[type]})),
            filteredValue: this.state.verifiedFilter,
            render: (verified) => verified ? <Tag color="#87d068">True</Tag> : <Tag color="#f50">False</Tag>
        },{
            title: 'Actions',
            render: (action, record) => record.verified ? '' : this.renderActionButtons(record._id, record.entityType, record.entityId)
        }
        // ,{
        //     title: 'Requested By',
        //     dataIndex: 'createdBy',
        //     render: (createdBy) => createdBy.name,
        //     filters: createdByList.map(type => ({text: type, value: type})),
        //     filteredValue: this.state.createdByFilter
        // },{
        //     title: 'Requested On',
        //     dataIndex: 'dateCreated',
        //     render: (dateCreated) => moment(dateCreated).format('LLL')
        // },{
        //     title: 'Status',
        //     dataIndex: 'status',
        //     render: (status) => this.renderTag(status),
        //     filters: Object.keys(STATUS).map(status => ({text: status, value: status})),
        //     filteredValue: this.state.statusFilter
        // },{
        //     title: 'Actions',
        //     render: (action, record) => record.completedBy ? record.completedBy.name : this.renderActionButtons(record._id)
        // }
    ]

    console.log({paymentAdvices})
        return (
            <Table
                onChange={this.handleTableChange}
                dataSource={paymentAdvices}
                columns={columns}
                pagination={{
                    pageSize: limit,
                    current: page,
                    total: paymentAdvicesCount,
                    onChange: (nextPage) => {
                        this.setState({ page: nextPage })
                    }
                }}
                expandedRowRender={(record) => this.renderExpandedRow(record) }
            />
        )
    }

    renderExpandedRow = (record) => {
        return (
            <div>
            {record.invoices.map(_invoice => {
                return (
                <Row>
                    <Col span={4}>{_invoice.refNumber}</Col>
                    <Col span={4}>{_invoice.amount}</Col>
                </Row>
                )
            })}
        </div>
        )
    }

    renderActionButtons = (paymentAdviceId, entityType, entityId) => {
        return (
            <div>
                <UploadButton 
                    paymentAdviceId={paymentAdviceId}
                    entityId={entityId}
                    entityType={entityType}
                    getPaymentAdvice={this.getPaymentAdvice}
                    />
                <Popconfirm
                    title="Confirm deletion?"
                    onConfirm={()=>this.handleDeletePaymentAdvice(paymentAdviceId)}
                >
                    <Button
                        type="danger"
                        style={{marginLeft: 10}}
                        >
                        Delete
                    </Button>
                </Popconfirm>
            </div>
        )
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={this.state[`${dataIndex}_search`]}
                    onChange={(e => this.setState({[`${dataIndex}_search`]: e.target.value}))}
                    onPressEnter={() => this.handleSearch(confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(confirm, dataIndex)}
                        icon='search'
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
              </Button>
                    <Button onClick={() => this.handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
              </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type='search' />,
        render: text => text
    });

    handleSearch = (confirm, dataIndex) => {
        confirm();
        // Page is set to 1 because if on handleSearch page==2 but results only has 1 page, cant see any results
        this.setState({
            page: 1
        }, this.getPaymentAdvice)
        
    };

    handleReset = (clearFilters, dataIndex) => {
        clearFilters();
        this.setState({ 
            [`${dataIndex}_search`]: '' 
        },this.getPaymentAdvice);
        
    };
    
    handleTableChange = (pagination, filters, sorter, extra) => {

        this.setState({
            current: pagination.current,
            entityTypeFilter: filters.entityType,
            verifiedFilter: filters.verified
        }, this.getPaymentAdvice)
    }

    closeNewPaymentAdviceModal = () => {
        this.setState({
            newPaymentAdviceModalVisible: false
        })
    }

    openNewPaymentAdviceModal = () => {
        this.setState({
            newPaymentAdviceModalVisible: true
        })
    }

    handleDeletePaymentAdvice = ( paymentAdviceId ) => {
        _deletePaymentAdvice({ paymentAdviceId })
        .then(_response => {
            this.getPaymentAdvice()
        })
    }
}

export default PaymentAdvice


// WEBPACK FOOTER //
// ./src/components/payment-advice/index.js